import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { WorkerService } from '../../features/worker/core/services/WorkerService';
import { BrowserUtils } from '../utils/BrowserUtils';
import { NotificationService } from './NotificationService';
import { ApiErrorResponse } from '../classes/ApiErrorResponse';
import { ShowsStore } from '../../features/shows/core/stores/ShowsStore';

@Injectable({
  providedIn: 'root'
})
export class CustomerScreenService {

  public readonly lastPingTime$ = new Subject<number>();
  public readonly lastPongTime$ = new Subject<number>();
  
  private _customerScreenWindow: Window;
  private readonly _workerService = inject(WorkerService);
  private readonly _notificationService = inject(NotificationService);
  private readonly _showsStore = inject(ShowsStore);

  public closeCustomerScreen(): void {
    if (BrowserUtils.isLocalhost) {
      this._customerScreenWindow?.close();
    } else {
      this._workerService.closeCustomerScreen().subscribe({
        error: ({ error }: ApiErrorResponse) => {
          this._notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`close-customer-screen/notifications/${error.message}.Message`)
          );
        }
      });
    }
  }

  public openCustomerScreen(): void {
    const url = `${location.origin}${`${this._showsStore.selectedShow() ? `/shows/${this._showsStore.selectedShow().id}` : '/blank-screen'}?isCustomerScreen=true`.langUrl()}`;

    if (BrowserUtils.isLocalhost) {
      this._customerScreenWindow = window.open(url, '_blank', `width=${screen.availWidth},height=${screen.availHeight},left=0,top=0`);
    } else {
      this._workerService.openCustomerScreen(url)
        .subscribe({
          error: ({ error }: ApiErrorResponse) => {
            this._notificationService.pushError(
              'Fehler'.trans('notifications/error.Title'),
              error.message.trans(`open-customer-screen/notifications/${error.message}.Message`)
            );
          }
        });
    }
  }
}
